// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 8013 ? "18b16e15" : chunkId) + "-" + {"7189":"3a03b67b65bb8d8d","8013":"baa630f86efa47b7"}[chunkId] + ".js";
};